import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { SelectChangeEvent } from "@mui/material";

const useMagnetSelector = () => {
  const addToQuote = useStore((state) => state.addToQuote);

  const pivotHardware = useStore((state) => state.quote.pivotHardware);
  const pivotAction = useStore((state) => state.quote.pivotAction);

  const pivotMagnet = useStore((state) => state.quote.pivotMagnet);
  const pivotMagnetColor = useStore((state) => state.quote.pivotMagnetColor);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const handleClick = (label: string) => {
    const checked = label === pivotMagnet;

    if (checked) {
      addToQuote({ pivotMagnet: "" }, "pivotMagnet");
    } else {
      addToQuote({ pivotMagnet: label });
    }
  };

  const handleChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    addToQuote({ pivotMagnetColor: value });
    if (value && findRequired("Magnet Finish")) removeRequired("Magnet Finish");
  };

  return {
    pivotHardware,
    pivotMagnet,
    pivotAction,
    pivotMagnetColor,
    handleClick,
    handleChange,
  };
};

export default useMagnetSelector;
